import { Pipe, PipeTransform } from '@angular/core';
import {isUndefined} from "util";

@Pipe({ name: 'price' })
export class PricePipe implements PipeTransform {

  /**
  * Toma value, que debe ser un number o un string que pueda convertirse a number, y devuelve
  * una string que es dicho value con separador de millares (elegimos el punto para el separador)
  * y con la coma decimal, si es que el valor original tenía decimales. Si no los tenía pero arg es
  * igual a 'fill' entonces agregamos la coma decimal seguida de un 0.
  **/
  transform(value: any, arg?: string) {
    if (typeof value === 'string' || typeof value === 'number') {
      if (typeof value === 'number') {
        value = String(value);
      }

      if (value && !Number.isNaN(Number(value))) {
        const absValue = Number(value) < 0 ? String(-Number(value)) : value;
        const tmp = absValue.split('.');
        const n = tmp[0].length;

        const int = (tmp[0].split('').map((c, i) => i < n - 1 && (n - 1 - i) % 3 === 0 ? c + '.' : c).join('') || '0');

        // si hay decimales, los usamos con la coma delante, de lo contrario queda vacío
        let float = tmp[1] && tmp[1].length ? `,${tmp[1]}` : '';

        const argSplit = arg ? arg.split(',') : [];

        // si hay decimales y necesitamos hacer un clamp
        if (float.length && arg === 'clamp') {
          float = `,${tmp[1].substring(0, 3)}`;
        } else {
          // si no hay decimales y queremos hacer un fill
          if (!float.length && arg === 'fill') {
            float = ',0';
          } else if (!isUndefined(arg) && arg.includes('fill,') && argSplit[1] && argSplit[1].length && !isNaN(Number(argSplit[1]))) {
            // si queremos hacer un fill con una cantidad definida de ceros, no importa si hay o no valores decimales
            float = this.addZero(float, Number(argSplit[1]));
          }
        }
        return Number(value) < 0 ? '-' + int + float : int + float;
      }
    }

	  return value;
  }

  private addZero(strToAdd, amount: number) {
    // en caso de no haber coma, la agregamos
    if (!strToAdd.includes(',')) {
      strToAdd = ',' + strToAdd;
    }
    // sumamos 1 porque el string llega con una coma delante, por lo que evita que se agregue el ultimo cero
    if (strToAdd.length < amount + 1) {
      do {
        strToAdd += '0';
      } while (strToAdd.length < (amount + 1));
    }
    return strToAdd;
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/pipes/price.ts